var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionDomains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1312 4.42698C20.1312 5.74231 16.5332 6.80859 12.0949 6.80859C7.65658 6.80859 4.05859 5.74231 4.05859 4.42698C4.05859 3.11166 7.65658 2.04537 12.0949 2.04537C16.5332 2.04537 20.1312 3.11166 20.1312 4.42698Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1312 9.49763C20.1312 10.9584 16.5332 12.1426 12.0949 12.1426C7.65658 12.1426 4.05859 10.9584 4.05859 9.49763",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1312 14.7877C20.1312 16.2792 16.5332 17.4883 12.0949 17.4883C7.65658 17.4883 4.05859 16.2792 4.05859 14.7877",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05859 4.42165V19.7068C4.05859 21.106 7.65658 22.2402 12.0949 22.2402C16.5332 22.2402 20.1312 21.106 20.1312 19.7068V4.42165",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionDomains);
export default __webpack_public_path__ + "static/media/sessionDomains.67427533f73d56a75d2ebee6bbdbfd34.svg";
export { ForwardRef as ReactComponent };